function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.38v12.64a11.24 11.24 0 003.309 7.967 11.228 11.228 0 007.958 3.308h4.151v-7.12h7.116V1.381c0-.556-.455-1.015-1.01-1.015h-5.091c-.556 0-1.01.455-1.01 1.015v16.794H11.27a4.136 4.136 0 01-2.929-1.222 4.136 4.136 0 01-1.222-2.929V1.381C7.12.825 6.666.366 6.11.366h-5.1C.454.366 0 .825 0 1.381z",
  fill: "#FFB21C"
});

function SvgGlobalUnitPayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "8f9f12974b66534bf0f67d0fc18d184f.svg";
export { SvgGlobalUnitPayIcon as ReactComponent };